import { PapiDeviation } from '@wix/da-types-papi';
import { AppState } from '../../types/store';
import { getDeviationById } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import MediaService from '@wix/da-shared-react/pkg/utils/DeviationMediaService';

import { getModuleDataByModuleType } from './modules';
import { ModuleType } from '../../types/modules';

export const getCoverDeviation = (
  state: AppState
): PapiDeviation | undefined => {
  const coverDeviationId = (
    getModuleDataByModuleType(state, ModuleType.COVER_DEVIATION) || {}
  ).coverDeviationId;
  return coverDeviationId
    ? (getDeviationById(state, coverDeviationId) as PapiDeviation)
    : undefined;
};

export const getCoverDeviationOffsetY = (state: AppState): number => {
  const coverDeviationidOffsetY =
    (getModuleDataByModuleType(state, ModuleType.COVER_DEVIATION) || {})
      .coverDeviationidOffsetY || 0;
  return coverDeviationidOffsetY;
};

export const getDeviationFileSrc = (
  deviation: PapiDeviation,
  fileType: string
) => {
  const deviationFile = MediaService.getDeviationFile(deviation, fileType);
  return (deviationFile && deviationFile.src) || '';
};
